import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../environments/environment';

export function getRequestBaseUrl(platformId: object): string {
    const { baseUrl, browserBaseUrl } = environment as typeof environment & { browserBaseUrl?: string };

    return isPlatformBrowser(platformId) ? browserBaseUrl ?? baseUrl : baseUrl;
}
